<template>
    <form @submit.prevent="$emit('submit')" class="space-y-6">
        <FormSection v-if="form.statuses">
            <template #title>
                Submissions
            </template>

            <statuses :statuses="form.statuses" :assignment="form" :assignmentLabel="assignmentLabel" />
            
        </FormSection>

        <FormSection>
            <template #title>
                Actions
            </template>

            <div v-if="form.new_status">
               <FormGroup
                    name="status"
                    label="Status">
                    <Select
                        v-model="form.status"
                        name="status"
                        :options="statusFilters"
                        placeholder="Update the status..."/>
                </FormGroup>

                <FormGroup
                    name="new_status.description"
                    label="Notes">
                    <Textarea
                        v-model="form.new_status.description"
                        name="description"
                        rows="3"
                        placeholder="Enter any notes..."/>
                </FormGroup>
            </div>            

            <template v-if="$slots.footer" #footer>
                <slot name="footer"></slot>
            </template>
        </FormSection>

    </form>
</template>

<script>

import {AssignmentStatus} from "@/Lib/Enums";
import FormSection from "@/Components/Form/FormSection.vue";
import FormGroup from "@/Components/Form/FormGroup.vue";
import Input from "@/Components/Form/Input.vue";
import Select from "@/Components/Form/Select.vue";
import File from "@/Components/Form/File.vue";
import Textarea from "@/Components/Form/Textarea.vue";
import InputError from "@/Components/Form/InputError.vue";
import Label from "@/Components/Form/Label.vue";
import Checkbox from "@/Components/Form/Checkbox.vue";
import Statuses from "@/Pages/Student/Assignment/Components/Statuses";
import {optionsToArray} from "@/Lib/Helpers";
import axios from "axios";

export default {

    name: "AssignmentForm",

    props: {
        assignment: {
            type: Object,
            default: () => ({})
        },
        assignmentLabel: {
            type: String,
            default: () => 'Assignment'
        },
        assignmentType: {
            type: Number,
            default: () => 1
        }
    },

    emits: ['submit'],

    data() {
        return {
            loaded: false,
            statusFilters: [
                {label: "Pending", value: AssignmentStatus.Pending},
                {label: "Accepted", value: AssignmentStatus.Accepted},
                {label: "Rejected", value: AssignmentStatus.Rejected},
            ],
        };
    },

    inject: ['form'],

    async created() {

        this.loaded = true;
    },

    components: {
        AssignmentStatus,
        FormSection,
        FormGroup,
        Input,
        Select,
        File,
        Textarea,
        Label,
        InputError,
        Checkbox,
        Statuses
    },

    methods: {
        
    },

    watch: {
        
    }
};

</script>
